import { pascalCase, pascalCaseTransformMerge } from "pascal-case";
const buildTypeName = (...parts) => {
  let name = pascalCase(parts.filter(Boolean).join(" "), {
    transform: pascalCaseTransformMerge
  });
  if (/^[0-9]/.test(name) ? "_" : "") {
    name = `_${name}`;
  }
  return name;
};
export {
  buildTypeName
};
//# sourceMappingURL=buildTypeName.js.map
